export function useCodeBoxPaste(shared) {
  const {getDigits, setBoxesFromCode, focusInput} = shared;

  function getFocusIndex(digits) {
    if (!digits.length) return -1;
    if (digits.length >= 6) return 5;
    return digits.length;
  }

  function handlePaste(event) {
    const pasted = event.clipboardData?.getData("text") || "";
    const digits = getDigits(pasted);
    if (!digits.length) return;
    setBoxesFromCode(pasted);
    const focusIndex = getFocusIndex(digits);
    if (focusIndex >= 0) focusInput(focusIndex);
    event.preventDefault();
  }

  return {handlePaste};
}
